import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import {
  withAccessDenied, withNotifications, withProgressAndErrorMessage, withRefresh, withRouter,
} from '@app/hocs'
import { withStyles } from '@app/components/styles'
import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectMultichannelActionSubDevice
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateAction/ZwaveMultichannelAction/SelectMultichannelActionSubDevice/SelectMultichannelActionSubDevice'
import SelectMultichannelActionSubDeviceIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateAction/ZwaveMultichannelAction/SelectMultichannelActionSubDevice/SelectMultichannelActionSubDevice'
import { saveCurrentActionSubdevice } from '@app/actions/scenes/currentSceneCreating'
import { syncSubDevices } from '@app/actions/scenes/zWaveDevices/subDevices'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(SelectMultichannelActionSubDeviceIOS) : withStyles(SelectMultichannelActionSubDevice)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { path } = state.shadowIn
  const { isChangeActionStateMode, isChangeActionMode, isEditActionMode } = state.scenes.currentSceneCreating
  const { subDevices } = state.scenes.subDevices
  const { name } = state.scenes.currentSceneCreating.currentAction.currentSubDevice
  const { stateDescription } = state.scenes.currentSceneCreating.currentAction
  return {
    isMobile,
    path,
    isChangeActionStateMode,
    isChangeActionMode,
    isEditActionMode,
    subDevices,
    name,
    stateDescription,
    inProgress: state.apiRequest.inProgress,
    errorMessage: state.apiRequest.errorMessage,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
  saveCurrentActionSubdevice,
  refresh: syncSubDevices,
  tryAgain: syncSubDevices,
}, dispatch)

enhance = withRefresh(enhance)
enhance = withProgressAndErrorMessage(enhance)
enhance = withAccessDenied(enhance)
enhance = withNotifications(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectMultichannelActionSubDeviceEnhanced = enhance

export default withRouter(SelectMultichannelActionSubDeviceEnhanced)
